import { Game, GameDatabase } from '~/types/game';
import useData from '../data/useData';

export const useGame = (gameID: string) => {
    const getSnapshot = () => GameDatabase.getGame(gameID);
    const game = useData<Game>(getSnapshot, [gameID]);
    return game;
};

export const useGames = (gameIDs: Array<string> = []) => {
    const getSnapshot = () => GameDatabase.getGames(gameIDs);
    const games = useData<Game[]>(getSnapshot, [gameIDs]);
    return games;
};

export const useAllGames = () => {
    const getSnapshot = () => GameDatabase.getGames('*');
    const games = useData<Game[]>(getSnapshot);
    return games;
};
